import './index.css';

import MyRoutes from '@/router';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
dayjs.locale('zh-cn');

ReactDOM.createRoot(document.getElementById('root')!).render(
  <ConfigProvider locale={zhCN}>
    <BrowserRouter basename={import.meta.env.VITE_PATH as string}>
      <MyRoutes />
    </BrowserRouter>
  </ConfigProvider>,
);
